import React from "react";
import Lottie from "lottie-react";
import PropTypes from "prop-types";

import logoAnimation from "assets/animations/logo.json";

type AnimatedLoaderProps = {
  size?: number;
};

const AnimatedLoader: React.FC<AnimatedLoaderProps> = function ({ size = 250 }) {
  return (
    <div className="animated-loader" style={{ width: size }} data-testid="animated-loader">
      <Lottie animationData={logoAnimation} loop />
    </div>
  );
};

export default AnimatedLoader;

AnimatedLoader.propTypes = {
  size: PropTypes.number,
};

AnimatedLoader.defaultProps = {
  size: 250,
};
